<ul class="layout-menu">
    <div class="sidebar-cancel hidden">
        <i class="pi pi-times-circle" style="font-size: 1.7rem; font-weight: 500; cursor: pointer;" (click)="layoutService.onMenuToggle()"></i>
    </div>
    <ng-container *ngFor="let item of model; let i = index">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul> 

